import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@mui/material'
import { useTheme } from '../../utils/themeContext'
import { getColorsForTheme } from '../../global-styles/clientColors'

const NotFound = () => {
  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)
  
  return (
    <div>
      <h1>404 - Not Found!</h1>
      <Link
        component={RouterLink}
        to="/"
        sx={{
          color: themeColors.buttonColor,
          '&:hover': {
            color: themeColors.buttonHover,
          },
        }}
      >
        Go Home
      </Link>
    </div>
  )
}

export default NotFound